// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './router'
import VueResource from 'vue-resource'
import Bootstrap from 'bootstrap-vue/dist/bootstrap-vue.esm'
import Router from 'vue-router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'

import VueProgressiveImage from 'vue-progressive-image'

import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

var LanguageController = require('./LanguageController')

const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.params.section !== undefined) {
      return {}
    }
    return savedPosition || { x: 0, y: 0 }
  }
})

Vue.use(VueResource)
Vue.use(Bootstrap)
Vue.use(Router)
Vue.use(VueProgressiveImage)

router.beforeEach(function (to, from, next) {
  let title = 'Dynalab'
  switch (LanguageController.getLanguage()) {
    case 'SE':
      title = 'Dynalab | ' + to.meta.titleSE
      break
    case 'EN':
      title = 'Dynalab | ' + to.meta.titleEN
      break
    default:
      break
  }
  document.title = title

  if (to.matched.length < 1) {
    next('/')
  } else {
    next()
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App :language="language" :showMenu="showMenu" :loggedIn="loggedIn"/>',
  data () {
    return {
      language: 'SE',
      showMenu: true,
      loggedIn: false
    }
  },
  watch: {
    loggedIn: function () {
      if (this.loggedIn) {
        this.showMenu = true
      } else {
        this.showMenu = false
      }
    }
  },
  methods: {
    toggleLoading: function () {
      this.showMenu = !this.showMenu
    },
    login: function () {
      this.loggedIn = true
    },
    logoff: function () {
      this.loggedIn = false
    },
    hideMenu: function () {
      this.showMenu = false
    },
    toggleMenu: function () {
      this.showMenu = !this.showMenu
    },
    setLanguage: function (language) {
      this.language = language
      LanguageController.setLanguage(language)
    },
    getLanguage: function () {
      return LanguageController.getLanguage()
    },
    getOppositeLanguage: function () {
      return LanguageController.getOppositeLanguage()
    },
    getHeader: function (section) {
      return LanguageController.getHeader(section)
    },
    getCategory: function (section, category) {
      return LanguageController.getCategory(section, category)
    },
    getCategoryForStart: function (section, category) {
      return LanguageController.getCategoryForStart(section, category)
    },
    getCategoryHeader: function (section, category) {
      return LanguageController.getCategoryHeader(section, category)
    },
    getCategorySummary: function (section, category) {
      return LanguageController.getCategorySummary(section, category)
    },
    getCategoryText: function (section, category) {
      return LanguageController.getCategoryText(section, category)
    },
    getCategoryListHeader: function (section, category) {
      return LanguageController.getCategoryListHeader(section, category)
    },
    getCategoryList: function (section, category) {
      return LanguageController.getCategoryList(section, category)
    },
    getSubcategories: function (section, category) {
      return LanguageController.getSubcategories(section, category)
    },
    getSummary: function (id) {
      return LanguageController.getSummary(id)
    },
    getText: function (id) {
      return LanguageController.getText(id)
    },
    getQuote: function (id) {
      return LanguageController.getQuote(id)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js